// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventVerificationDefault
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.verification.PresentmentRecord
import kotlin.time.Duration
import org.multipaz.verification.toDataItem
import org.multipaz.verification.fromDataItem

fun EventVerificationDefault.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "6-R4CnKL3oQwGCv815_WGZFnawFQT941klaOj5EqYI0")
val EventVerificationDefault_cborSchemaId = ByteString(-21, -28, 120, 10, 114, -117, -34, -124, 48, 24, 43, -4, -41, -97, -42, 25, -111, 103, 107, 1, 80, 79, -34, 53, -110, 86, -114, -113, -111, 42, 96, -115)

fun EventVerificationDefault.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Verification")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentRecord", this.presentmentRecord.toDataItem())
    val durationRequestSentToResponseReceived = this.durationRequestSentToResponseReceived
    if (durationRequestSentToResponseReceived != null) {
        builder.put("durationRequestSentToResponseReceived", Tstr(durationRequestSentToResponseReceived.toIsoString()))
    }
    return builder.end().build()
}

fun EventVerificationDefault_fromDataItem(dataItem: DataItem): EventVerificationDefault {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentRecord = PresentmentRecord.fromDataItem(dataItem["presentmentRecord"])
    val durationRequestSentToResponseReceived0 = if (dataItem.hasKey("durationRequestSentToResponseReceived")) {
        dataItem["durationRequestSentToResponseReceived"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    return EventVerificationDefault(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentRecord = presentmentRecord,
        durationRequestSentToResponseReceived = durationRequestSentToResponseReceived0,
    )
}
